<template>
  <div class="wg-row">
    <!-- Modale visualizzazione report a schermo -->
    <wg-modal
      :width="'800px'"
      v-if="report"
      @closeModal="closeReport"
    >
      <div slot="body" class="wg-row no-select">
        <div class="vertical-height-div" style="height:20px;"></div>
        <!-- Show report -->
        <div id="report" class="report">
          <!-- Title -->
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">
              {{ report.title }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- header -->
          <div class="wg-row header">
            <div v-for="(h, i) in report.header" :key="'h-'+i" :class="h.class">
              {{ h.label }}
            </div>
          </div>
          <!-- Lines -->
          <div v-for="(l,i) in report.lines" :key="'l-'+i" class="wg-row line">
            <div v-for="(e,j) in l" :key="'e-'+j" :class="report.header[j].class">
              {{ e }}
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <!-- Buttons to print with pc or printer -->
        <div class="wg-row" style="flex-wrap:nowrap;justify-content:center;">
          <div
            v-for="(printer) in printers"
            :key="printer.idPrinter"
            class="display-flex action-btn-with-desc"
            style="margin:0 10px;"
          >
            <img
              :src="$anm22.icons.getWorldIcon('print')"
              class="btn print-button-nfis"
              :title="printer.name"
              @click="print(printer.idPrinter);"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ printer.name }}</div>
          </div>
          <div
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('fileDefault')"
              class="btn print-button-nfis"
              :title="'Browser'"
              @click="print()"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Print with browser', 'Stampa con browser') }}</div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Pagina principale -->
    <div style="font-size:24px;margin: 25px 0;">
      {{ $anm22.strLang(lang, 'Daily Reports', 'Report giornalieri') }}
    </div>
    <!-- Selezione data di riferimento -->
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'From', 'Da') }}</div>
      <input @change="checkDates('f')" type="date" v-model="from" style="margin-left:20px;">
      <div class="com-anm22-app-text-xl" style="margin-left:20px;">{{ $anm22.strLang(lang, 'To', 'A') }}</div>
      <input @change="checkDates('t')" type="date" v-model="to" style="margin-left:20px;">
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 
        'All reports refers to data from 05:00 on the selected date to 05 am on the following day', 
        'Tutti i report si riferiscono ai dati registrati dalle 05:00 della data selezionata alle 05:00 del giorno seguente') }}</div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;max-width:400px;">
      <div class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Products report', 'Report prodotti') }} 
      </div>
      <button class="small" @click="loadReport(1)">
        <div>
          {{ $anm22.strLang(lang, 'Print', 'Stampa') }}
        </div>
      </button>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;max-width:400px;">
      <div class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Register report', 'Report cassa') }} 
      </div>
      <button class="small" @click="loadReport(2)">
        <div>
          {{ $anm22.strLang(lang, 'Print', 'Stampa') }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: {
      type: String,
      default: "Europe/Rome"
    }
  },
  data() {
    return {
      from: this.$moment.tz(this.timezone).format('YYYY-MM-DD'),
      to: this.$moment.tz(this.timezone).format('YYYY-MM-DD'),
      report: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    printers() {
      return this.$store.getters["foodPrinters/getByLicense"](
        this.license.id
      ).filter(p => p.printMode.text);
    },
  },
  methods: {
    checkDates(target) {
      const from = this.$moment.tz(this.from, 'YYYY-MM-DD', this.timezone);
      const to = this.$moment.tz(this.to, 'YYYY-MM-DD', this.timezone);
      if(target === 'f') {
        if(from.isAfter(to)) {
          this.to = this.from;
        }
      } else {
        if(to.isBefore(from)) {
          this.from = this.to;
        }
      }
    },
    async loadReport(type) {
      // Ask data to server
      const response = await this.$http.post('settings/generate-report', {
        from: this.from,
        to: this.to,
        type
      });
      if(response.data.error) {
        this.$anm22.eventBus.$emit('world-headbar-show-message', {
          text: response.data.error.message[this.lang],
          type: "alarm"
        });
      } else {
        const report = {
          title: '',
          header: [],
          lines: [],
        };
        switch(type) {
          case 1:
            report.title = this.$anm22.strLang(this.lang, 'Products detail report', 'Report dettaglio prodotti');
            report.header = [
              { class: 'wg-xs-6', width: 66.67, label: this.$anm22.strLang(this.lang, 'Name', 'Nome') },
              { class: 'wg-xs-3 right', width: 33.33, label: this.$anm22.strLang(this.lang, 'Amount', 'Importo') },
              { class: 'wg-xs-3 right', width: 33.33, label: this.$anm22.strLang(this.lang, 'Qti.', 'Qtà') },
            ];
            let total = 0, quantity = 0;
            response.data.categories.forEach(c => {
              report.lines.push([]);
              const cid = c.id;
              let c_total = 0, c_quantity = 0;
              report.lines.push([ c.name, '', '' ]);
              response.data.products.filter(p => p.category == cid).forEach(p => {
                const pid = p.id;
                report.lines.push([ p.name, p.total.toFixed(2), p.quantity.toFixed(2) ]);
                c_total += p.total;
                c_quantity += p.quantity;
              });
              report.lines.push([ this.$anm22.strLang(this.lang, 'Total', 'Totale'), c_total.toFixed(2), c_quantity.toFixed(2) ]);
              total += c_total;
              quantity += c_quantity;
            });
            // Total
            report.lines.push([]);
            report.lines.push([ this.$anm22.strLang(this.lang, 'Total', 'Totale'), total.toFixed(2), quantity.toFixed(2) ]);
            break;
          case 2:
            report.title = this.$anm22.strLang(this.lang, 'Register report', 'Report cassa');
            report.header = [
              { class: 'wg-xs-6', width: 66.67, label: this.$anm22.strLang(this.lang, 'Description', 'Descrizione') },
              { class: 'wg-xs-3 right', width: 33.33, label: this.$anm22.strLang(this.lang, 'Amount', 'Importo') },
              { class: 'wg-xs-3 right', width: 33.33, label: this.$anm22.strLang(this.lang, 'Qti.', 'Qtà') },
            ];
            report.lines.push([]);
            let pm_total = 0, pm_quantity = 0;
            response.data.pms.forEach(pm => {
              const obj = this.$anm22.tableClasses.worldPaymentModeType().getById(pm.id);
              report.lines.push([ obj[this.lang] , pm.total.toFixed(2), pm.quantity.toFixed(2) ]);
              pm_total += pm.total;
              pm_quantity += pm.quantity;
            });
            report.lines.push([ this.$anm22.strLang(this.lang, 'Total', 'Totale'), pm_total.toFixed(2), pm_quantity.toFixed(2) ]);
            report.lines.push([]);
            let rt_total = 0, rt_quantity = 0;
            response.data.rts.forEach(rt => {
              const obj = this.$anm22.tableClasses.worldReceiptType().getById(rt.id);
              if(obj['typeClass']) {
                report.lines.push([ obj[this.lang] , rt.total.toFixed(2), rt.quantity.toFixed(2) ]);
              } else {
                report.lines.push([ this.$anm22.strLang(this.lang, 'Movements', 'Movimenti') , rt.total.toFixed(2), rt.quantity.toFixed(2) ]);
              }
              rt_total += rt.total;
              rt_quantity += rt.quantity;
            });
            report.lines.push([ this.$anm22.strLang(this.lang, 'Total', 'Totale'), rt_total.toFixed(2), rt_quantity.toFixed(2) ]);
            report.lines.push([]);
            // Storni
            report.lines.push([ 
              this.$anm22.strLang(this.lang, 'Deleted', 'Storni'),
              response.data.storni.total.toFixed(2), 
              response.data.storni.quantity.toFixed(2) 
            ]);
            // Discounts
            report.lines.push([ 
              this.$anm22.strLang(this.lang, 'Discounts', 'Sconti'),
              response.data.discount.total.toFixed(2), 
              response.data.discount.quantity.toFixed(2) 
            ]);
            // Surcharge
            report.lines.push([ 
              this.$anm22.strLang(this.lang, 'Surcharges', 'Costi di servizio'),
              response.data.surcharge.total.toFixed(2), 
              response.data.surcharge.quantity.toFixed(2) 
            ]);
            report.lines.push([]);
            report.lines.push([ 
              this.$anm22.strLang(this.lang, 'Register total', 'Totale incassi'),
              response.data.payedTotal.toFixed(2), 
              ''
            ]);
            report.lines.push([]);
            report.lines.push([ 
              this.$anm22.strLang(this.lang, 'Orders not payed', 'Ordini non pagati'),
              response.data.notPayed.total.toFixed(2), 
              response.data.notPayed.quantity.toFixed(2) 
            ]);
            break;
        }
        this.report = report;
      }
    },
    closeReport() {
      this.report = null;
    },
    print(pid) {
      // if printer undefined print with browser
      if(pid) {
        const content = new WorldPrintContent();
        content.printMode = 'text';

        let body = '', line_width = 45;

        // title
        body += this.report.title;
        body += "\n";
        // header
        let s_header = '';
        this.report.header.forEach((h,i) => {
          const field_width = Math.round(line_width / 100 * h.width);
          if(i === 0) {
            s_header += h.label.padEnd(field_width, ' ');
          } else {
            s_header += h.label.padStart(field_width, ' ');
          }
        });
        body += "\n" + s_header;
        // lines
        this.report.lines.forEach(l => {
          let s_line = '';
          l.forEach((e,i) => {
            const field_width = Math.round(line_width / 100 * this.report.header[i].width);
            if(e.length > field_width) {
              e = e.substring(0, field_width);
            }
            if(i === 0) {
              s_line += e.padEnd(field_width, ' ');
            } else {
              s_line += e.padStart(field_width, ' ');
            }
          });
          body += "\n" + s_line;
        });

        content.text = body;
        window['world_printer_'+pid].print(content);

      } else {
        const html = document.getElementById("report").cloneNode(true);

        // Get all stylesheets HTML
        const headElements = [],
          inserted = [];
        for (const node of [...document.querySelectorAll('link[href$=".css"], style')]) {
          // stylesHtml += node.innerHTML;
          if (node.tagName === "STYLE") {
            const elem = document.createElement("style");
            elem.type = "text/css";
            elem.innerHTML = node.innerHTML;
            headElements.push(elem);
          } else {
            if (!inserted.find(s => s === node.href)) {
              inserted.push(node.href);
              const elem = document.createElement("link");
              elem.type = "text/css";
              elem.rel = "stylesheet";
              elem.href = node.href;
              headElements.push(elem);
            }
          }
        }
        console.log(html);
        this.$anm22.print(html, headElements);
      }
    },
    loadPrinters() {
      this.printers.forEach(p => {
        window.createPrinter(p, process.env.VUE_APP_BACK_DOMAIN);
      });
    },
  },
  created() {
    this.loadPrinters();
  }
}
</script>

<style lang="scss" scoped>
.report {
  height: 90%;
  width: 100%;
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
  overflow-y: auto;

  div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .header {
    border-bottom: 1px solid #ddd;
    font-weight: bold;
    padding: 2px 0;
  }
  .line {
    height: 16px;
  }
  .right {
    text-align: right;
  }
}

.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}

@media print {
  .report {
    margin: 0;
    padding: 20px 0 0 0;
    font-size: 12px;
    width: 210mm;
    height: 297mm;
    border: none;
    box-shadow: none;
  }
}
</style>